import {ArrowNarrowLeftIcon} from '@heroicons/react/outline';
import {useNavigate, useParams} from 'react-router-dom';

import {Header} from '@/components';

import BusinessLiveAccessNotesTable from './BusinessLiveAccessNotesTable';
import {useBusinessLiveAccessLog} from './useBusinessLiveAccessLog';

const BusinessLiveAccessLogsScreen = () => {
  const {businessId, requestId} = useParams();
  const navigate = useNavigate();
  const {request, isLoading, resolveActor, forLabel} = useBusinessLiveAccessLog(
    requestId,
    businessId,
  );

  const renderLogs = () => {
    if (isLoading) {
      return (
        <div className="mt-6">
          <BusinessLiveAccessNotesTable isLoading />
        </div>
      );
    }

    if (!request) {
      return (
        <p
          data-cy="live-access-logs-not-found"
          className="text-sm text-gray-500 dark:text-gray-400 py-10 text-center"
        >
          Live access request not found.
        </p>
      );
    }

    return (
      <div className="mt-6">
        <div className="mb-2 flex flex-wrap gap-x-8 gap-y-1">
          <p className="text-sm text-gray-500 dark:text-gray-300">
            Request ID:{' '}
            <span
              className="font-medium text-gray-800 dark:text-gray-100"
              data-cy="live-access-logs-request-id"
            >
              {request.id}
            </span>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-300">
            For:{' '}
            <span
              className="font-medium text-gray-800 dark:text-gray-100"
              data-cy="live-access-logs-for"
            >
              {forLabel}
            </span>
          </p>
        </div>
        <BusinessLiveAccessNotesTable
          isLoading={false}
          notes={request.notes}
          resolveActor={resolveActor}
        />
      </div>
    );
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <div className="flex items-center gap-3">
        <Header
          title=""
          icon={
            <div
              className="flex text-blue-500 cursor-pointer"
              data-cy="live-access-logs-back"
              onClick={() => navigate(-1)}
            >
              <ArrowNarrowLeftIcon className="font-light w-5 h-5 dark:text-white hover:text-indigo-500 dark:hover:text-indigo-500 mr-3" />
              <span className="font-medium">Back</span>
            </div>
          }
        />
      </div>

      {renderLogs()}
    </main>
  );
};

export default BusinessLiveAccessLogsScreen;
